import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

import terapia1 from "./../assets/terapia1.jpg";
import natacion1 from "./../assets/natacion1.jpg";
import natIco1 from "./../assets/icons/natIco1.png";
import ubicacion from "./../assets/icons/ubicacion.png";
import relog from "./../assets/icons/relog.png";
import ninos from "./../assets/icons/ninos.png";
import puzzle from "./../assets/icons/puzzle.png";

const transferFeatures = [
  {
    id: 1,
    name: "Descripción de la terapia",
    description:
      "El objetivo principal es potenciar el desarrollo de los niños, favoreciendo su participación y desempeño en las distintas actividades del día a día. Se utiliza como herramienta terapéutica el juego, ya que es la ocupación más significativa en la infancia y el eje de su desarrollo cognitivo, social y emocional.",
    icon: puzzle,
    color: "bg-primary-lighter",
    iconBg: "bg-primary",
  },
  {
    id: 2,
    name: "Población objetivo",
    description: "Atención: 0 a 18 años",
    icon: ninos,
    color: "bg-primary-lighter",
    iconBg: "bg-primary",
  },
  {
    id: 3,
    name: "Duración de las sesiones",
    description: "45 minutos",
    icon: relog,
    color: "bg-primary-lighter",
    iconBg: "bg-primary",
  },
  {
    id: 4,
    name: "Lugares",
    description: "Centro Volantín",
    icon: ubicacion,
    color: "bg-primary-lighter",
    iconBg: "bg-primary",
  },
];

const communicationFeatures = [
  {
    id: 1,
    name: "Descripción de las clases",
    description:
      "Iniciación en el medio acuático desde los 2 años, familiarización y seguridad en el agua, inmersión, salto y piqueros, flotación con y sin apoyo, desplazamiento en el medio acuático hasta técnica y estilos de nado (mariposa, espalda, pecho y crol).",
    icon: natIco1,
    color: "bg-ocean-lighter",
    iconBg: "bg-ocean",
  },
  {
    id: 2,
    name: "Población objetivo",
    description: "2 años en adelante",
    icon: ninos,
    color: "bg-ocean-lighter",
    iconBg: "bg-ocean",
  },
  {
    id: 3,
    name: "Duración de las clases",
    description: "45 minutos",
    icon: relog,
    color: "bg-ocean-lighter",
    iconBg: "bg-ocean",
  },
  {
    id: 4,
    name: "Lugares",
    description: "A Domicilio y Piscina Municipal Vitacura",
    icon: ubicacion,
    color: "bg-ocean-lighter",
    iconBg: "bg-ocean",
  },
];

export default function Trayectoria() {
  useEffect(() => {
    Aos.init({ duration: 1500, once: true });
  }, []);

  return (
    <section className="bg-white overflow-hidden" id="servicios">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">

        {/* Section header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-warm-lighter text-warm font-body font-semibold text-sm px-4 py-1.5 rounded-full mb-3">
            ¿Qué ofrezco?
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl font-semibold text-gray-800">
            Servicios
          </h2>
          <p className="mt-3 text-gray-500 font-body text-base max-w-lg mx-auto">
            Dos áreas de expertise para el desarrollo integral de niños y jóvenes
          </p>
        </div>

        {/* ── Terapia Ocupacional ── */}
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center mb-24">
          {/* Text */}
          <div data-aos="fade-right">
            <div className="inline-flex items-center gap-2 bg-primary-lighter rounded-2xl px-4 py-2 mb-4">
              <div className="w-3 h-3 bg-primary rounded-full" />
              <span className="font-body font-semibold text-primary text-sm">Terapia Ocupacional</span>
            </div>

            <h3 className="font-heading text-3xl sm:text-4xl font-semibold text-gray-800 mb-4">
              Terapia Ocupacional
            </h3>
            <p className="text-gray-600 font-body text-base leading-relaxed mb-8">
              La Terapia Ocupacional es una profesión del área de la salud que
              mira al ser humano como un ser ocupacional e integral y tiene como
              objetivo principal facilitar, mantener y mejorar el desempeño de
              las personas en sus actividades del día a día, promoviendo su
              independencia y participación en todos sus contextos.
            </p>

            <div className="space-y-4 mb-8">
              {transferFeatures.map((item, index) => (
                <div
                  key={item.id}
                  className="flex gap-4 p-4 rounded-2xl bg-gray-50 hover:bg-primary-lighter transition-colors duration-200"
                  data-aos="fade-right"
                  data-aos-delay={index * 100}
                >
                  <div className={`flex-shrink-0 w-12 h-12 ${item.iconBg} rounded-2xl flex items-center justify-center shadow-soft`}>
                    <img src={item.icon} alt="" className="h-6 w-6 object-contain" />
                  </div>
                  <div>
                    <p className="font-heading font-semibold text-gray-800 mb-0.5">{item.name}</p>
                    <p className="text-sm text-gray-500 font-body leading-relaxed">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="https://encuadrado.com/p/barbara-zamora/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold px-8 py-4 rounded-2xl shadow-soft transition-all duration-200 hover:scale-105 hover:shadow-lg text-base cursor-pointer"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Reservar en Centro Volantín
            </a>
          </div>

          {/* Image */}
          <div className="mt-10 lg:mt-0 flex justify-center" data-aos="fade-left">
            <div className="relative max-w-md w-full">
              <div className="absolute inset-0 bg-primary opacity-10 rounded-4xl transform rotate-3 scale-95 blur-sm" />
              <img
                className="relative rounded-4xl shadow-soft-lg w-full object-cover border-4 border-white"
                src={terapia1}
                alt="Sesión de Terapia Ocupacional"
              />
              <div className="absolute -top-4 -right-4 bg-primary text-white font-heading font-semibold px-4 py-2 rounded-2xl shadow-soft text-sm">
                Pediatría
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="flex items-center gap-4 mb-24">
          <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />
          <div className="w-3 h-3 bg-warm rounded-full" />
          <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />
        </div>

        {/* ── Clases de Natación ── */}
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
          {/* Image first on desktop */}
          <div className="mb-10 lg:mb-0 flex justify-center" data-aos="fade-right">
            <div className="relative max-w-md w-full">
              <div className="absolute inset-0 bg-ocean opacity-10 rounded-4xl transform -rotate-3 scale-95 blur-sm" />
              <img
                className="relative rounded-4xl shadow-ocean w-full object-cover border-4 border-white"
                src={natacion1}
                alt="Clases de Natación"
              />
              <div className="absolute -top-4 -left-4 bg-ocean text-white font-heading font-semibold px-4 py-2 rounded-2xl shadow-ocean text-sm">
                Desde 2 años
              </div>
            </div>
          </div>

          {/* Text */}
          <div data-aos="fade-left">
            <div className="inline-flex items-center gap-2 bg-ocean-lighter rounded-2xl px-4 py-2 mb-4">
              <div className="w-3 h-3 bg-ocean rounded-full" />
              <span className="font-body font-semibold text-ocean text-sm">Natación</span>
            </div>

            <h3 className="font-heading text-3xl sm:text-4xl font-semibold text-gray-800 mb-4">
              Clases de Natación
            </h3>
            <p className="text-gray-600 font-body text-base leading-relaxed mb-8">
              Experiencia de 7 años realizando clases de natación a niños y
              adultos. Un espacio seguro y divertido para aprender a nadar y
              desarrollar confianza en el agua.
            </p>

            <div className="space-y-4 mb-8">
              {communicationFeatures.map((item, index) => (
                <div
                  key={item.id}
                  className="flex gap-4 p-4 rounded-2xl bg-gray-50 hover:bg-ocean-lighter transition-colors duration-200"
                  data-aos="fade-left"
                  data-aos-delay={index * 100}
                >
                  <div className={`flex-shrink-0 w-12 h-12 ${item.iconBg} rounded-2xl flex items-center justify-center shadow-ocean`}>
                    <img src={item.icon} alt="" className="h-6 w-6 object-contain" />
                  </div>
                  <div>
                    <p className="font-heading font-semibold text-gray-800 mb-0.5">{item.name}</p>
                    <p className="text-sm text-gray-500 font-body leading-relaxed">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://api.whatsapp.com/send?phone=56966088903&text="
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-ocean hover:bg-ocean-dark text-white font-body font-bold px-6 py-4 rounded-2xl shadow-ocean transition-all duration-200 hover:scale-105 hover:shadow-lg text-sm cursor-pointer"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                Reservar a Domicilio
              </a>
              {/* <a
                href="https://carereservas.site.agendapro.com/cl/sucursal/84887"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-white border-2 border-ocean text-ocean hover:bg-ocean hover:text-white font-body font-bold px-6 py-4 rounded-2xl transition-all duration-200 hover:scale-105 text-sm cursor-pointer"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                Reservar en Centro Care
              </a> */}
            </div>
          </div>
        </div>
      </div>

      {/* Wave */}
      <div className="w-full overflow-hidden leading-none">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" preserveAspectRatio="none">
          <path d="M0,0 C720,60 720,60 1440,0 L1440,60 L0,60 Z" fill="#EEF2FF" />
        </svg>
      </div>
    </section>
  );
}
